import { render, staticRenderFns } from "./subOperateSkillOrCommonSummaryNew.vue?vue&type=template&id=83470f74&scoped=true"
import script from "./subOperateSkillOrCommonSummaryNew.vue?vue&type=script&lang=js"
export * from "./subOperateSkillOrCommonSummaryNew.vue?vue&type=script&lang=js"
import style0 from "./subOperateSkillOrCommonSummaryNew.vue?vue&type=style&index=0&id=83470f74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83470f74",
  null
  
)

export default component.exports